<template>
    <div class="warehouse_add_wrap" v-loading="loading">
        <div class="warehouse_add_top">
            <div class="warehouse_add_code_identification">
                <div></div>
                <el-button  size="small" type="primary" @click="handleClickCodeIdentification">编码识别</el-button>
            </div>

            <div class="warehouse_add_table">
                <el-table class="custom_table" :data="formData.productData" border  ref="table"  max-height="530">

                    <el-table-column label="出库仓库" prop="stock_id"   width="226px" class-name="tableInputColumn">
                        <template #header>
                            <span style="margin-right: 4px">出库仓库</span>
                            <el-popover placement="bottom" ref="stockPopover">
                                <span slot="reference">
                                    <el-tooltip class="item" content="批量出库" effect="dark" placement="top">
                                        <span class="handle_icon_wrap"><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                    </el-tooltip>
                                </span>
                                <el-select   class="tableInput" placeholder="请选择出库仓库"  remote    reserve-keyword filterable  v-model="stock_id">
                                    <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in stockList" @click.native="handleChangeProductStockAll(item)"> </el-option>
                                </el-select>
                            </el-popover>
                        </template>
                        <template slot-scope="{row}">
                            <el-select v-model="row.stock_id" @focus="handleFocusStock(row)" clearable  filterable  placeholder="请选择出库仓库" remote reserve-keyword @clear="handleClickClearStock(row)">
                                <el-option  :label="item.name" :value="item.id" @click.native="handleClickProductStock(item,row)" v-for="item in row.name ? row.stock_list : stockList"> </el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <el-table-column label="产品名称" prop="name"   class-name=" tableInputColumn"	 min-width="434px">
                        <template slot-scope="{row}">
                            <div class="product_name_flex">
<!--                                <el-select v-model="row.name" placeholder="请输入产品名称" remote  reserve-keyword clearable filterable  @focus="getProductRemoteMethod(row.name,row)" @change="handleSelectProduct($event,row)"  :remote-method="query=>getProductRemoteMethod(query,row)" >-->
<!--                                    <el-option :key="item.id" :label="item.name" :value="item.name" v-for="item in productList"> </el-option>-->
<!--                                </el-select>-->

                                <el-autocomplete size="small" v-model="row.name" value-key="name"  :fetch-suggestions="(queryString, cb) => getProductRemoteMethod(queryString, cb, row)" placeholder="请输入产品名称" @blur="handleBlurSelectProduct(row)" @select="handleSelectProduct($event,row)">
                                    <template slot-scope="{ item }">
                                        <div class="flex_js_wrap" :class="{ 'disabled-item':  item.disabled }">
                                            <div class="product_name ellipsis">{{ item.name }}</div>
                                            <div class="product_tag" v-if="item.disabled">无库存</div>
                                        </div>
                                    </template>
                                </el-autocomplete>

                                <el-tooltip class="item" effect="dark" content="更多产品" placement="top">
                                     <span class="handle_icon_wrap" @click="handleClickSelectProduct(row)">
                                        <i class="iconfont icon-cangku1"></i>
                                    </span>
                                </el-tooltip>

                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="库存数量" prop="stock_num" show-overflow-tooltip  width="90px" >
                        <template slot-scope="{row}">
                            <span v-text="row.stock_info.total_num"></span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单位" prop="unit" show-overflow-tooltip  width="80px" ></el-table-column>


                    <el-table-column label="出库数量/产品编码" prop="id" min-width="332px"  class-name="tableInputColumn">
                        <template slot-scope="{row}">
                            <div class="product_num_code">
                                <el-input type="mini" v-model="row.no_code_num" :disabled="row.stock_info.no_code_num > 0 ? false :true" placeholder="请输入数量" @change="handleChangeNum(row)"></el-input>
                                <div class="line"></div>
                                <div class="change_code">
                                    <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="hover">
                                            <span class="change_code_wrap" slot="reference" @click="handleClickSelectCode(row)">
                                               <i class="el-icon-circle-plus-outline"></i>
                                               <span>选择编码</span>
                                            </span>
                                        <div class="product_code_wrap">
                                            <ul>
                                                <li class="ellipsis" v-for="item in row.code_list" v-text="item.code"></li>
                                            </ul>
                                            <div class="code_num_wrap">
                                                共：{{ row.code_list.length}}条
                                            </div>
                                        </div>
                                    </el-popover>
                                </div>
                                <div class="total_num">
                                    共<span v-if="row.total_num" v-text="row.total_num"></span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="58" align="center">
                        <template slot-scope="{row,$index}">
                            <el-tooltip placement="top" content="删除行" >
                              <span class="handle_icon_wrap handle_icon_danger_wrap" @click="handleClickDel(row,$index)">
                                  <i class="iconfont icon-shanchu1"></i>
                              </span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add_product_btn">
                    <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增行</span>
                </div>
            </div>

            <div class="warehouse_add_from">
                <el-form ref="formData"  :model="formData"  :rules="formDataRules"  label-position="top"  size="small">
                    <el-form-item label="附件" class="label-bold" prop="file_list">
                        <div class="file_upload_wrap">
                            <div v-if="formData.file_list.length===0" class="file_outer_wrap">
                                <img alt=""  src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"  width="36">
                                <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                                <p class="file_type_hint">支持.rar .zip .doc .docx .pdf .jpg...</p>
                                <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            </div>
                            <ul v-else class="upload_file_list">
                                <li v-for="file in formData.file_list" class="upload_file_item">
                                    <div class="file_left_wrap">
                                        <img alt="" class="file_img"  src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                        <div class="file_info_wrap">
                                            <p class="file_name" v-text="file.file_name"></p>
                                            <p class="file_size" v-text="file.file_size"></p>
                                        </div>
                                    </div>
                                    <div class="file_right_wrap">
                                        <el-tooltip content="预览"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                        </el-tooltip>
                                        <span class="line"></span>
                                        <el-tooltip content="删除"  effect="dark"  placement="top">
                                            <span class="handle_icon_wrap handle_icon_danger_wrap"  @click="formData.file_list.splice(file_idx,1)">
                                                <i class="iconfont icon-shanchu1"></i>
                                            </span>
                                        </el-tooltip>
                                    </div>
                                </li>
                                <li class="upload_file_btn_wrap">
                                    <i class="el-icon-plus"></i>
                                    <span>添加附件</span>
                                    <input class="upload_input"  multiple  type="file"  @change="handleUploadFileChange($event)">
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注信息" class="label-bold" prop="note">
                        <el-input type="textarea" :rows="5" v-model="formData.note" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="warehouse_add_bottom">
            <el-button size="small" @click="handleClickClose">取消</el-button>
            <el-button :disabled="btnDisabled" size="small" type="primary" @click="handleClickConfirm">提交</el-button>
        </div>
        <SelectProductOut :selectProductOutDialog.sync="selectProductOutDialog" v-if="selectProductOutDialog" :selectStockId="productInfo.stock_id" :selectPorductName="productInfo.name" @success="selectProductSuccess" />
        <CodeIdentification :codeIdentificationDialog.sync="codeIdentificationDialog" v-if="codeIdentificationDialog" :sourceType="'out'" :productInfo="productInfo" :selectedCodeData="selectedCodeData" @success="identificationCodeSuccess" />
        <SelectCode :selectCodeDialog.sync="selectCodeDialog" v-if="selectCodeDialog" :productInfo="productInfo" @success="selectCodeSuccess"></SelectCode>
        <el-image :preview-src-list="previewImgList" :src="previewImgSrc" ref="preview_img" style="display: none"></el-image>

    </div>
</template>
<script>
import {mapState} from "vuex";
import {stockList,searchOutProducts,addStockOut,chooseCode,codeOutGetProduct,getStocksByProduct,getStocksAuth} from "@/api/index.js"
import {formatFileSize,removeTag} from "@/utils";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import SelectProductOut from  "../component/select_product_out"
import CodeIdentification from  "../component/code_identification"
import SelectCode from  "../component/select_code"
import {EventBus} from '@/utils/eventBus';
export default {
    name: 'OutWarehouseAdd',
    components: {
        SelectProductOut,
        CodeIdentification,
        SelectCode
    },
    data() {
        return {
            loading:false,
            btnDisabled:false,
            formData:{
                productData:[
                    {
                        name:'',
                        stock_id:'',
                        sku_id:'',
                        sku_key:'',
                        unit:'台',
                        code_num:0, //选择的编码数量
                        code_list:[], //选择的编码
                        no_code_num:0, //选择的无编码数量
                        total_num:0, //选择的总数量
                        stock_info:{
                            code_num:0, //在库编码数量
                            no_code_num:0, //在库无编码数量
                            total_num:0, //在库的总数量
                        },
                        stock_list:[]
                    }
                ],
                file_list:[],
                note:''
            },
            formDataRules:{},
            stock_id:'',
            stockOptions:[],
            codeIdentificationDialog:false, //选择编码/编码识别
            selectedCodeData:[],
            productInfo:null,//选中的产品
            selectProductOutDialog:false,//选择入库产品
            productId:0,
            selectCodeDialog:false,
            stockList:[],
            productList:[],
            previewImgList: [],
            previewImgSrc: "",
            project_manage_id:0
        }
    },
    computed: {
        ...mapState(['inventoryProductData']),
        ...mapState(['tagList'])
    },
    mounted() {

    },
    created() {
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.setInventoryProductData(this.inventoryProductData)
        }
        if(this.$route.query.project_manage_id){
            this.project_manage_id = this.$route.query.project_manage_id
        }

        this.getStockList()
    },
    watch: {
        $route: {
            handler(to, from) {
                if(to.params.from && to.params.from == 'warehouse'){
                    this.$route.meta.parentMeta = {
                        title: '仓库管理',
                        path: '/warehouse_management',
                        icon: "icon-shezhi",
                    }
                }else if(from && from.name == 'OutWarehouseManagement'){
                    this.$route.meta.parentMeta = {
                        title: '出库管理',
                        path: '/out_warehouse_management',
                        icon: "icon-shezhi",
                    }
                }
            },
            immediate: true, // 可选，是否立即执行
            deep: true // 如果路由有嵌套参数可能需要
        },
        // "inventoryProductData": function (newVal,oldVal) {
        //     if(newVal && newVal.length){
        //         this.setInventoryProductData(newVal)
        //     }
        // }
    },
    activated() {
        // 组件被激活
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.setInventoryProductData(this.inventoryProductData)
        }
    },
    methods: {
        setInventoryProductData(data){
            if(data && data.length){
                this.formData.productData = []
                data.forEach((item)=>{
                    let json = {
                        name:item.name,
                        stock_id:item.stock_id,
                        sku_id:item.sku_id,
                        sku_key:item.sku_key,
                        unit:item.unit,
                        code_num:0, //选择的编码数量
                        code_list:[], //选择的编码
                        no_code_num:0, //选择的无编码数量
                        total_num:0, //选择的总数量
                        stock_info:{
                            code_num:item.stock_id ? item.code_num :0, //在库编码数量
                            no_code_num:item.stock_id ? item.no_code_num : 0, //在库无编码数量
                            total_num:item.stock_id ? item.total_num : 0, //在库的总数量
                        },
                        stock_list:item.stock_id ? [
                            {
                                id:item.stock_id,
                                name:item.stocks.name,
                                code_num:item.code_num ? item.code_num :0, //在库编码数量
                                no_code_num:item.no_code_num ? item.no_code_num : 0, //在库无编码数量
                                total_num:item.total_num ? item.total_num : 0, //在库的总数量
                            }
                        ] : []
                    }
                    this.formData.productData.push(json)
                })
                this.$store.dispatch("inventoryProductData", []);
            }
        },
        // 获取仓库
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.stockList = res.data
                }
            })
        },
        // 批量选择仓库
        handleChangeProductStockAll(item){
            let postData = {
                stock_id:item.id,
                product_list:this.formData.productData
                        .filter(find => find.name)
                        .map(map => {
                            return {
                                product_name: map.name,
                                sku_id: map.sku_id,
                                sku_key: map.sku_key
                            };
               })
            }
            getStocksAuth(postData).then(res => {
                if (res.code === 200) {
                    let dataInfo = res.data
                    this.formData.productData.forEach(list => {
                        let productItem = dataInfo.find(find => find.product_name == list.name && find.sku_id == list.sku_id && find.sku_key == list.sku_key && find.total_num > 0)
                        let stock_auth = productItem?.stock_auth

                        if(stock_auth){
                            this.handleClickClearStock(list)
                            let stock_info = {
                                id:item.id,
                                name:item.name,
                                no_code_num:productItem.no_code_num,
                                code_num:productItem.code_num,
                                total_num:productItem.total_num,
                            }
                            this.$set(list,'stock_info',stock_info)
                            this.$set(list,'stock_id',stock_info.id)
                            this.$set(list,'stock_name',stock_info.name)
                            this.$set(list,'stock_list',[
                                stock_info
                            ])
                        }else{
                            this.handleClickClearStock(list)
                            if(!list.name){
                                this.$set(list,'stock_id',item.id)
                            }
                        }
                        if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                            this.$message.error(`${productItem.product_name}已存在`)
                            this.$set(list,'stock_id','')
                            this.handleClickClearStock(list)
                        }
                    })
                }
            })
            this.$forceUpdate()
            this.stock_id = ''
            this.$refs.stockPopover.doClose()
        },
        // 根据产品获取仓库
        handleFocusStock(row){
            if(row.name){
                let postData  = {
                    product_name:row.name,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                }
                getStocksByProduct(postData).then(res => {
                    if (res.code === 200) {
                        let data = res.data ? res.data.map((item)=>{
                            return {
                                id:item.stock_id,
                                name:item.stocks.name,
                                code_num:item.code_num,
                                no_code_num:item.no_code_num,
                                total_num:item.total_num,
                            }
                        }) : []
                        this.$set(row,'stock_list',data)
                    }
                })
            }
        },
        // 选择单个仓库
        handleClickProductStock(item,row) {
            this.handleClickClearStock(row)
            if(row.name){
                let stock_info = row.stock_list.find(find => find.id == item.id)
                if(stock_info){
                    this.$set(row,'stock_info',stock_info)
                }
            }
            this.$nextTick(()=>{
                if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                    this.$message.error(`${row.name}已存在`)
                    this.$set(row,'stock_id','')
                    this.handleClickClearStock(row)
                    return false
                }
            })
        },
        // 清除仓库
        handleClickClearStock(row){
            this.$set(row,'code_num',0)
            this.$set(row,'code_list',[])
            this.$set(row,'no_code_num',0)
            this.$set(row,'total_num',0)
            this.$set(row,'stock_info',{code_num:0,no_code_num:0,total_num:0})
        },

        // 获取产品
        getProductRemoteMethod(queryString, cb, row){
            let postData  = {
                keyword:queryString,
                stock_id:(row && row.stock_id) ? row.stock_id :''
            }
            searchOutProducts(postData).then(res => {
                if (res.code === 200) {
                    let data = res.data ? res.data.map((item)=>{
                        item.disabled = item.zero_stock == true ? true : false
                        return item
                    }) : []
                    this.productList = data
                    cb(data);
                }
            })
        },

        handleBlurSelectProduct(row){
            let info = this.productList.find(find => find.name == row.name)
            if(!info){
                this.clearInfoData(row)
            }else{
                this.handleSelectProduct(info,row)
            }
        },
        // 选择产品
        handleSelectProduct(event,row){
            if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                this.$message.error(`${event.name}已存在`)
                this.clearInfoData(row)
                return false
            }
            let info = this.productList.find(find => find.name == event.name)
            if(info.disabled){
                this.$message.error(`该产品无库存`)
                this.$set(row,'name','')
                return false
            }
            this.$set(row,'sku_id',info.sku_id)
            this.$set(row,'sku_key',info.sku_key)
            this.$set(row,'unit',info.unit)

            this.handleClickClearStock(row)
            if(row.stock_id){
                // 有仓库id 的情况下 获取产品信息时带出的仓库才会是有权限的仓库
                this.$set(row,'stock_list',row.stock_id ? info.stocks : [])
                let stock_info = row.stock_list.find(find => find.id == row.stock_id)
                if(stock_info){
                    this.$set(row,'stock_info',stock_info)
                }else{
                    this.$set(row,'stock_id','')
                    this.$set(row,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
                }
            }
        },
        clearInfoData(row){
            this.$set(row,'name','')
            this.$set(row,'sku_id','')
            this.$set(row,'sku_key','')
            this.$set(row,'unit','个')
            this.$set(row,'stock_list',[])
            this.$set(row,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
            this.$set(row,'code_num',0)
            this.$set(row,'code_list',[])
            this.$set(row,'no_code_num',0)
            this.$set(row,'total_num',0)

        },
        // 编码识别
        handleClickCodeIdentification(){
            this.productId = 0
            this.productInfo = null
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationDialog = true
        },
        identificationCodeSuccess(data){
            this.loading = true
            let code_list = []
            if(this.formData.productData.length == 1){
                if(!this.formData.productData[0].stock_id && !this.formData.productData[0].name && !this.formData.productData[0].total_num) {
                    this.formData.productData.splice(0,1)
                }
            }
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = data.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != data.code_list.length){
                this.$message.error('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){ this.loading = false;  return  false }

            codeOutGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item)
                    })
                }
                this.loading = false
            })
        },
        // 合并产品
        mergeProductFunction(row){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.stock_id == row.stock_id){
                        let code_list = row.code_list.map((map)=>{return {code:map}})
                        this.$set(item,'code_list',item.code_list.concat(code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        flag = false
                    }
                })
            }
            if(flag){
                let stock_info = row.stocks.find(find => find.id == row.stock_id)
                let json = {
                    name:row.name,
                    stock_id:row.stock_id,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                    unit:row.unit,
                    code_num:row.code_num, //选择的编码数量
                    code_list:row.code_list.map((map)=>{return {code:map}}), //选择的编码
                    no_code_num:row.no_code_num, //选择的编码数量
                    total_num:row.total_num, //选择的总数量
                    stock_info:{
                        code_num:stock_info.code_num, //在库编码数量
                        no_code_num:stock_info.no_code_num, //在库无编码数量
                        total_num:stock_info.total_num, //在库的总数量
                    },
                    stock_list:row.stocks
                }
                this.formData.productData.push(json)
            }

        },

        VerifyDuplicate(){
            let data =  JSON.parse(JSON.stringify(this.formData.productData))
            const seen = new Map();
            const duplicates = [];
            data.forEach((item, index) => {
                const key = `${item.name}_${item.stock_id}`;
                if (seen.has(key) && item.name && item.stock_id) {
                    duplicates.push({ current: item, previousIndex: seen.get(key) });
                } else {
                    seen.set(key, index);
                }
            });
            return duplicates;
        },


        // 删除
        handleClickDel(row,index){
            if(this.formData.productData.length == 1) return this.$message.error('当前数据行不可删除，最少保留一行')
            this.formData.productData.splice(index,1)
        },
        // 新增行
        handleClickAdd(){
            let json = {
                name:'',
                stock_id:'',
                sku_id:'',
                sku_key:'',
                unit:'台',
                code_num:0, //选择的编码数量
                code_list:[], //选择的编码
                no_code_num:0, //选择的无编码数量
                total_num:0, //选择的总数量
                stock_info:{
                    code_num:0, //在库编码数量
                    no_code_num:0, //在库无编码数量
                    total_num:0, //在库的总数量
                },
                stock_list:[]
            }
            this.formData.productData.push(json)
        },
        // 输入数量
        handleChangeNum(row){
            const num = row.no_code_num;
            const regex = /^[1-9]\d*$/; // 正整数的正则表达式
            if (!regex.test(num) || !row.stock_id) {
                this.$set(row,'no_code_num',0)
            } else {
                // // 如果输入的数量大于总数量则等于总数量
                if(row.no_code_num > row.stock_info.total_num){
                    this.$set(row,'no_code_num',row.stock_info.total_num)
                }
                // // 如果输入的数量大于无编码总数量则等于无编码总数量  并把多余的数量变为有编码的
                if(row.no_code_num > row.stock_info.no_code_num){
                    let remaining =  row.no_code_num  - row.stock_info.no_code_num // 多余的数量
                    this.$set(row,'no_code_num',row.stock_info.no_code_num)
                    this.automatic_replenishment(row,remaining) //自动补充编码
                }else{
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                }

            }
        },
        // 自动补充编码
        automatic_replenishment(row,remaining){
            let postData = {
                page: 1,
                pageSize: remaining + row.code_list.length, // 需要自动选择的编码+已经选择了的编码
                product_name:row.name,
                sku_id:row.sku_id,
                sku_key:row.sku_key,
                stock_id:row.stock_id,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(row.code_list.map(item => item.code));
                    // 过滤 list，获取不在 code_list 中的值  并且状态是正常的编码
                    const filteredList = list.filter(item => !existingCodes.has(item.code) && item.status == 0);
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    row.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(row,'code_num',row.code_list.length)
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '库存数量已自动补充',
                        message: h('div', null, [
                            h('span', null, '此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '知道了' ,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: false,
                        confirmButtonClass: 'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {

                    }).catch(() => {

                    })
                }else{
                    this.btnDisabled = false
                }
            })
        },
        // 选择产品编码
        handleClickSelectCode(row){
            if(!row.name){ return this.$message.error('请先选择产品')}
            if(!row.stock_id){return this.$message.error('请先选择出库仓库')}
            if(row.stock_info && row.stock_info.code_num == 0){
                return this.$message.error('该产品在该库中无编码产品')
            }
            this.productInfo = row
            this.productId = row.id
            this.selectCodeDialog = true
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
            this.productInfo = null
        },
        // 选择产品
        handleClickSelectProduct(row){
            this.productInfo = row
            this.selectProductOutDialog = true
        },
        // 选择产品回调
        selectProductSuccess(data){
            this.$set(this.productInfo,'name',data.name)
            if(this.VerifyDuplicate() && this.VerifyDuplicate().length){
                this.$message.error(`${data.name}已存在`)
                this.$set(this.productInfo,'name','')
                return false
            }
            this.$set(this.productInfo,'sku_id',data.sku_id)
            this.$set(this.productInfo,'sku_key',data.sku_key)
            this.$set(this.productInfo,'stock_id',data.stock_id)
            this.$set(this.productInfo,'unit',data.unit)
            this.$set(this.productInfo,'stock_list',[data.stocks])
            this.$set(this.productInfo,'stock_info',{ code_num:data.code_num,no_code_num:data.no_code_num,total_num:data.total_num,})
            this.$set(this.productInfo,'code_num',0)
            this.$set(this.productInfo,'code_list',[])
            this.$set(this.productInfo,'no_code_num',0)
            this.$set(this.productInfo,'total_num',0)
            // if(this.productInfo.stock_id){
            //     let stock_info = this.productInfo.stock_list.find(find => find.id == this.productInfo.stock_id)
            //     if(stock_info){
            //         this.$set(this.productInfo,'stock_info',stock_info)
            //     }else{
            //         this.$set(this.productInfo,'stock_info',{ code_num:0,no_code_num:0,total_num:0,})
            //         this.$set(this.productInfo,'stock_id','')
            //     }
            // }
        },

        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type.indexOf("image") > -1) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickClose(){
            if (this.formData.note || this.formData.file_list.length > 0 || (this.formData.productData.length > 0 && this.formData.productData.filter(item => (item.name || item.stock_id || item.total_num )).length>0 )){
                const h = this.$createElement;
                this.$msgbox({
                    title: '取消',
                    message: h('div', null, [
                        h('span', null, '取消后，编辑内容不保留，是否取消！'),
                    ]),
                    iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                    customClass: 'prompt_message_custom',
                    confirmButtonText:  '确定',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showCancelButton: true,
                    confirmButtonClass:  'el-button--primary',
                    beforeClose: (action, instance, done) => {
                        if (action === 'confirm') {
                            done();
                        } else {
                            done();
                        }
                    }
                }).then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                }).catch(() => {
                })
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm(){
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    let flag = false
                    let productData = JSON.parse(JSON.stringify(this.formData.productData))
                    if(productData.length == 0){return this.$message.error(`至少出库一个产品`) }
                    productData.forEach((item,index) => {
                        if(!item.name && !flag){
                            this.$message.error(`请选择第${index+1}个产品`)
                            flag = true
                        }
                        if(!item.stock_id && !flag){
                            this.$message.error(`请选择${item.name}仓库`)
                            flag = true
                        }
                        if(!item.total_num && !flag){
                            this.$message.error(`请输入${item.name}出库数量`)
                            flag = true
                        }
                        if(item.code_list && item.code_list.length>0){
                            this.$set(item, 'code_list', item.code_list.map(codeItem => codeItem.code));
                        }
                        delete item.stock_info
                        delete item.stock_list
                    })
                    if(flag){return  false}
                    let postData = {
                        stock_type:'general', //出入库类型（普通）
                        product_list:productData,
                        files:this.formData.file_list,
                        note:this.formData.note,
                    }
                    if(this.project_manage_id){
                        postData.related_type = 'project_manage' //业务类型 （项目）
                        postData.related_id = this.project_manage_id
                    }
                    const h = this.$createElement;
                    this.$msgbox({
                        title: '提交出库',
                        message: h('div', null, [
                            h('span', null, '确定执行出库操作吗？ \r\n 提交后无法撤回，请谨慎操作。'),
                        ]),
                        iconClass: `icon-jinggao iconfont prompt_message_icon status1`,
                        customClass: 'prompt_message_custom',
                        confirmButtonText:  '确定',
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        showCancelButton: true,
                        confirmButtonClass:  'el-button--primary',
                        beforeClose: (action, instance, done) => {
                            if (action === 'confirm') {
                                done();
                            } else {
                                done();
                            }
                        }
                    }).then(() => {
                        this.btnDisabled = true
                        addStockOut(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message:'出库成功',
                                    duration: 1500,
                                    onClose: () => {
                                        EventBus.$emit('inventoryOutUpdated');
                                        removeTag(this.$route)
                                        this.$router.go(-1);
                                        this.btnDisabled = false
                                    }
                                })
                            }else{
                                this.btnDisabled = false
                            }
                        })
                    }).catch(() => {
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped >

@import "@/styles/inventory_management.scss";
</style>